import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, requireOwner = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] text-white grid place-items-center">
        <div className="flex items-center gap-3 text-[#A1A1AA] text-sm">
          <Loader2 className="w-4 h-4 animate-spin" /> Loading…
        </div>
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (requireOwner && user.role !== "owner") {
    return (
      <div className="min-h-screen bg-[#0A0A0A] text-white grid place-items-center">
        <div className="text-center">
          <div className="text-[10px] tracking-[0.3em] text-[#52525B] font-bold mb-3">// 403</div>
          <div className="font-display text-2xl font-bold tracking-tighter mb-2">Owner access required.</div>
          <div className="text-sm text-[#A1A1AA]">Ask the owner if you need access to this area.</div>
        </div>
      </div>
    );
  }

  return children;
}
